<template>
  <div class="card-bundle">
    <div class="col-sm-6 div-img">
      <template-carousel
          :class="{'template-images' : bundle.product_type_id == 4}"
          :show-pagination="false"
          :images="bundle.main_image">
      </template-carousel>
    </div>
    <div class="col-sm-6 div-content">
      <div class="card-bundle-body">
        <product-content
            :custom-class="customClass"
            :product="bundle">
        </product-content>
      </div>
    </div>
    <div class="col-md-12 card-bundle-footer">
      <a :href="linkShow()" class="btn btn-purchase">CONFIRA</a>
    </div>
  </div>
</template>
<script>
  import ProductContent from './ProductContent.vue';
  import TemplateCarousel from "./TemplateCarousel";

  export default {
    name: 'card-horizontal',

    components: {
      TemplateCarousel,
      'product-content': ProductContent,
    },

    props: {
      bundle: Object,
      customClass: {
        required: false,
      },
      isPagination: {
        default: false,
      }
    },

    methods: {
      linkShow() {
        return this.bundle.link_show;
      },
    },
  };
</script>
<style scoped>
  .div-img {
    padding: 0;
    position: relative;
    display: inline-block;
    align-content: center;
    width: 45%;
    height: 80%;
    min-height: 232px;
  }

  .div-content {
    height: 80%;
  }

  .card-bundle-body p {
    margin: 0;
    font-family: 'Montserrat', "Helvetica Neue", sans-serif;
    color: #24323b;
  }

  .card-bundle-body {
    height: 100%;
  }

  .card-title {
    margin-top: 0;
  }

  .price {
    padding-top: 18px;
  }

  .card-bundle {
    overflow: hidden;
    background-color: white;
    padding: 10px;
    height: 100%;
  }

  .card-bundle-footer {
    padding: 0;
  }

  .btn-purchase:hover {
    background-color: #e6bc00;
  }

  .btn-purchase {
    width: 100%;
    margin-top: 20px;
    border-radius: 6.79px;
    background-color: #FFD400;
    color: #333333;
    font-family: 'Montserrat', "Helvetica Neue", sans-serif;
  }

  .promotional {
    text-decoration: line-through;
    text-decoration-color: #ED1763;
  }

  .arrow-container {
    bottom: 0;
    left: 0;
    position: absolute;
  }

  .arrow-discount {
    height: 24px;
    background: #ED1763;
    width: 50px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    font-weight: bold;
    color: #FFD400;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .arrow-discount:after {
    content: "";
    position: absolute;
    height: 0;
    width: 0;
    left: 100%;
    top: 0;
    border: 12px solid transparent;
    border-left: 10px solid #ED1763;
  }

  .main-img {
    max-height: 220px;
    border: 1px solid rgb(128, 128, 128);
  }

  @media (max-width: 983px) {
    .main-img {
      margin: auto;
      width: auto !important;
    }

    .div-img {
      width: 100%;
    }
  }

  .max-height {
    max-height: 224px;
  }
</style>

<style>
  @media screen and (max-width: 768px) {
    .max-height img {
      position: relative;
    }
  }

  .max-height img {
    position: fixed;
  }

  .swiper-container .swiper-slide {
    min-height: -webkit-fill-available;
    line-height: 300px;
  }

  .swiper-container {
    overflow: visible;
  }

  .template-images img {
    outline: 1px solid #323232;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/store/components/CardHorizontal.vue